import React from 'react';
import './testimonial.css';

export function TestimonialMessage(props) {
    return (
    <div class="column">
    <div class="card" id = "card-div"style = {{width: "100% !important"}}>
      <img src={props.testimonial} alt="Jane" style={{width:"100%"}}/>
      <div class="container">
        <h4>Jane Doe</h4>
        <p class="title">CEO & Founder</p>
        <p>Some text that describes me lorem ipsum ipsum lorem.</p>
        <p>example@example.com</p>
        <p><button class="button">Contact</button></p>
      </div>
    </div>
  </div>
  )
}